// extracted by mini-css-extract-plugin
module.exports = {"baseFlex":"Ctas_baseFlex__wrB8e","cta":"Ctas_cta__ybuzw","center":"Ctas_center__DzEDL","black":"Ctas_black__8413T","largeGap":"Ctas_largeGap__Jy3hv"};